import { render, staticRenderFns } from "./WebsocketDemo.vue?vue&type=template&id=aba8635e&"
import script from "./WebsocketDemo.vue?vue&type=script&lang=js&"
export * from "./WebsocketDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports